import React from 'react'

type TProps = {
  children: React.ReactNode
}

const ModalTitle = ({ children }: TProps) => <h3 className="Modal_Title">{children}</h3>

export default ModalTitle
